import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    boardIndex: 0,
    loginFlag: false,
    switchTitle: '',
    isVirtually: true,
    costName: '',
    // ---------
    searchtype: 0,
    historyList: [],
    firstLoading: true, //该路由第一次加载
    step: 1,
    activeObj: null,
    createType: '',
    oldPlayerNum: 0,
    introStep: 0
  },
  mutations: {
    addBoardIndex(state) {
      state.boardIndex++
    },
    changeLoginFlag(state, data) {
      state.loginFlag = data
    },
    changeSwitchTitle(state, data) {
      state.switchTitle = data
    },
    changeVirtually(state, data) {
      state.isVirtually = data
    },
    changeCostName(state, data) {
      state.costName = data
    },
    // -----------------------AR----------
    changeSearchType(state, data) {
      state.searchtype = data
    },
    getHistroyRecord(state, data) {
      state.historyList = data
    },
    getFirstLoading(state, data) {
      state.firstLoading = data
    },
    changeAddStep(state) {
      state.step++
    },
    changeReduceStep(state) {
      state.step--
    },
    changeStep(state, data) {
      state.step = data
    },
    changeActiveObj(state, data) {
      state.activeObj = data
    },
    // 检测左边组件，
    changeSelectType(state, data) {
      state.createType = data
    },
    changeOldPlayer(state) {
      state.oldPlayerNum++
    },
    changeIntroStep(state, step){
      state.introStep = step
    }
  },
  actions: {},
  modules: {}
})
